import moment from 'moment';

import { SUPPRESSION_EXPIRY_WARNING_DAYS, SUPPRESSION_TYPES } from '@/constants/suppression';

export function isTemporary(suppression) {
  return !!suppression && suppression.type === SUPPRESSION_TYPES.TEMPORARY;
}

/** Whole days until expiry, counted on calendar days in the user's timezone (0 = expires today). */
export function daysUntilExpiry(suppression, now = moment()) {
  if (!isTemporary(suppression) || !suppression.expiresAt) {
    return null;
  }
  return Math.max(0, moment(suppression.expiresAt).startOf('day').diff(moment(now).startOf('day'), 'days'));
}

export function isExpiringSoon(suppression, now = moment()) {
  const days = daysUntilExpiry(suppression, now);
  return days !== null && days <= SUPPRESSION_EXPIRY_WARNING_DAYS;
}

/**
 * Status key used by CentralizedIssueStatus: suppressed findings show their suppression
 * instead of new / open / fixed.
 */
export function issueStatusKey(issue) {
  if (issue && issue.suppression) {
    return isTemporary(issue.suppression) ? 'temporaryException' : 'suppressed';
  }
  return issue && issue.status;
}

/** Expiry sent to the backend: end of the chosen day in the user's timezone, as ISO UTC. */
export function endOfDayIso(dateString) {
  return moment(dateString, 'YYYY-MM-DD').endOf('day').toISOString();
}

export function formatSuppressionDate(date) {
  return date ? moment(date).format('DD MMM YYYY') : '';
}
